import React, { useContext } from 'react'
import { Hydrator } from '@usap/core'
import { LocalContext } from '../../../../helpers/useLocalContext'
import ShopByBrand from './ShopByBrand.loadable'

const ShopByBrandLazyLoader = props => {
  const { localContext } = useContext(LocalContext)
  const { isBot } = localContext

  return (
    <Hydrator
      Component={ShopByBrand}
      lazy={!isBot}
      {...props}
    />
  )
}

export default ShopByBrandLazyLoader
